import Chat from "Components/Chat/Chat";
import { Denied } from "Components/_PageComponents/Fallback";
import { Answer, Avatar, AWSLiveChat, Convlog, Dashboard, FAQ, FLE, Home, Initialize, RequestLog, System, T2VATrainer, Talk2VA, Training, Workspace, GPTSettings, Report } from "Pages";
import GPTConvlog from "Pages/gpt-qa/convlog/GPTConvlog";
import GPTQADocumentManager from "Pages/gpt-qa/document-manager";
import { GPTQADashboard } from "Pages/gpt-qa";
import { CounterExample, Entity, Intent } from "Pages/Workspace";
import { AnswerReview, SurveyResult, LiveAgent, Eservice, FrequentlyAsk, Traffic, APIUsage } from "Pages/Report";

interface IRoute {
  path: string;
  element: JSX.Element;
  key?: string;
}
export const CMS_ROUTES: IRoute[] = [
  { path: "", element: <Home /> },
  { path: "Denied", element: <Denied /> },
  { path: "/Dashboard", element: <Dashboard /> },
  { path: "Report", element: <Report /> },
  { path: "Report/AnswerReview", element: <AnswerReview /> },
  { path: "Report/SurveyResult", element: <SurveyResult /> },
  { path: "Report/LiveAgent", element: <LiveAgent /> },
  { path: "Report/Eservice", element: <Eservice /> },
  { path: "Report/FrequentlyAsk", element: <FrequentlyAsk /> },
  { path: "Report/Traffic", element: <Traffic /> },
  { path: "Report/APIUsage", element: <APIUsage /> },
  { path: "Convlog", element: <Convlog /> },
  { path: "RequestLog", element: <RequestLog /> },
  { path: "Talk2VA", element: <Talk2VA /> },
  { path: "FAQ", element: <FAQ /> },
  { path: "Training", element: <Training /> },
  { path: "Answer", element: <Answer /> },
  { path: "Workspace", element: <Workspace /> },
  { path: "Workspace/Intent", element: <Intent /> },
  { path: "Workspace/Entity", element: <Entity /> },
  { path: "FAQ/CounterExample", element: <CounterExample /> },
  { path: "System", element: <System /> },
  { path: "T2VATrainer", element: <T2VATrainer /> },
  { key: "aws", path: "AWSLiveChat", element: <AWSLiveChat /> },
  { path: "FLE", element: <FLE /> },
  { path: "Initialize", element: <Initialize /> },
  { path: "/TestChat", element: <Chat /> },
  { path: "/gpt-qa/document-manager", element: <GPTQADocumentManager /> },
  { path: "/gpt-qa/conversation-log", element: <GPTConvlog /> },
  { path: "/gpt-qa/gpt-setting", element: <GPTSettings /> },
  { path: "/gpt-qa/gpt-qa-dashboard", element: <GPTQADashboard /> },
];
